/* unplugin-vue-components disabled */import { render } from "./KilaKilaHotArticleCard.vue?vue&type=template&id=0675adc0&scoped=true"
import script from "./KilaKilaHotArticleCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaHotArticleCard.vue?vue&type=script&lang=js"

import "./KilaKilaHotArticleCard.vue?vue&type=style&index=0&id=0675adc0&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0675adc0"]])

export default __exports__